import React, { FC, useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { PageTitle } from '../../../_metronic/layout/core'
import Select from 'react-select';
import { fetchData, getEncryptedRoute, getTranslatedValue, toasterrormsg, toastsuccessmsg, useMenuIdPermissions, buildDropdownAudit } from '../../../reusable';
import { ToastContainer } from 'react-toastify';
import { AddRestaurantHeader } from './AddRestaurantHeader';
import { Tr } from '../../../_metronic/i18n/Tr';
import { useLang } from '../../../_metronic/i18n/Metronici18n';

const tmp = sessionStorage.getItem('admin')
const adminId = tmp ? JSON.parse(tmp)?.adminId ?? '' : ''

const AddRestaurantFacilities: FC = () => {
    let t = Tr()
    const lang = useLang()
    const location = useLocation();
    const { menuId } = useMenuIdPermissions()

    const editRestaurantId = (location.state as any)?.restaurantId || '';
    const [restaurantDetails, setRestaurantDetails] = useState([]);

    var vendorId = "";
    const vendorData = sessionStorage.getItem("vendor");
    if (vendorData) {
        var vendor = JSON.parse(vendorData);
        vendorId = vendor.vendorId;

    } else {

    }
    const navigate = useNavigate()
    const [loading, setLoading] = useState(false)
    const [disable, setDisable] = useState(false);

    // sub category list state start
    const [ambienceList, setAmbienceList] = useState([]);
    const [ambienceSelectedOptions, setAmbienceSelectedOptions] = useState<any>([]);
    const ambienceId = ambienceSelectedOptions ? ambienceSelectedOptions.map((option: any) => option.value).join(',') : "";
    // sub category list state end

    // amenities list state start
    const [amenitiesList, setAmenitiesList] = useState([]);
    const [amenitiesSelectedOptions, setAmenitiesSelectedOptions] = useState<any>([]);
    const amenityId = amenitiesSelectedOptions ? amenitiesSelectedOptions.map((option: any) => option.value).join(',') : "";
    // amenities list state end

    // amenities list state start
    const [cuisineList, setCuisineList] = useState([]);
    const [cuisineSelectedOptions, setCuisineSelectedOptions] = useState<any>();
    // amenities list state end

    // old dropdown states for audit labels
    const [oldAmenities, setOldAmenities] = useState<any>(null)
    const [oldAmbience, setOldAmbience] = useState<any>(null)
    const [oldCuisine, setOldCuisine] = useState<any>(null)

    // set error state
    const [error, setError] = useState([{

        amenityId: '',
        cuisineId: '',
        ambience: '',
    }])

    // remove validation function
    const removeError = (err: any) => {
        var tmp = [...error] as any;
        tmp[0][err] = "";
        setError(tmp);
    }

    // amenityList api call
    const amenityListAPIcall = async () => {

        var param = {
            'categoryId': '3'
        }
        var res = await fetchData('vendor/public/amenityList', param)

        if (res.status == "200") {
            var opt: any = []
            res.data.map((val: any) => {
                opt.push({ value: val.amenityId, label: getTranslatedValue(lang, val, '_name') })
            })
            setAmenitiesList(opt)
        }
        else {
            toasterrormsg(res.message)
        }
    }
    // ambience List api call
    const ambienceListAPIcall = async () => {

        var res = await fetchData('vendor/public/ambienceList', [])

        if (res.status == "200") {
            var opt: any = []
            res.data.map((val: any) => {
                opt.push({ value: val.ambienceId, label: getTranslatedValue(lang, val, '_name') })
            })
            setAmbienceList(opt)
        }
        else {
            toasterrormsg(res.message)
        }
    }
    // cuisine List api call
    const cuisineListAPIcall = async () => {

        var res = await fetchData('vendor/public/cuisineList', [])

        if (res.status == "200") {
            var opt: any = []
            res.data.map((val: any) => {
                opt.push({ value: val.cuisineId, label: getTranslatedValue(lang, val, '_name') })
            })
            setCuisineList(opt)
        }
        else {
            toasterrormsg(res.message)
        }
    }
    // validation function
    const validate = () => {

        var isValid = true;
        var errorTmp = [...error];

        if (amenitiesSelectedOptions.length == 0) {
            errorTmp[0].amenityId = t('Restaurant Amenities Is Required');
            isValid = false;
        }
        if (cuisineSelectedOptions == "" || cuisineSelectedOptions == null || cuisineSelectedOptions == undefined) {
            errorTmp[0].cuisineId = t('Cuisine Is Required');
            isValid = false;
        }
        if (ambienceSelectedOptions == "" || ambienceSelectedOptions == null || ambienceSelectedOptions == undefined) {
            errorTmp[0].ambience = t('Ambience Is Required');
            isValid = false;
        }

        setError(errorTmp);
        return isValid;
    }
    // add hotel api call
    const addRestaurantFacilitiesApi = async () => {

        if (validate()) {

            setDisable(true)
            setLoading(true);
            let param: any = {
                restaurantId: String(editRestaurantId),
                adminId: adminId,
                amenityId: amenityId,
                ambienceId: ambienceId,
                cuisineId: cuisineSelectedOptions.value,
                labels: buildDropdownAudit({
                    amenityId: { old: oldAmenities, new: amenitiesSelectedOptions, multi: true },
                    ambienceId: { old: oldAmbience, new: ambienceSelectedOptions, multi: true },
                    cuisineId: { old: oldCuisine, new: cuisineSelectedOptions },
                }),
            }

            var res = await fetchData('vendor/public/addResturantFacilities', param)
            if (res.status == "200") {
                toastsuccessmsg("Facilities Added Successfully!")
                const state = {
                    restaurantId: editRestaurantId
                }
                setTimeout(() => {
                    navigate(getEncryptedRoute('../addrestaurantavailability/', { menuId: menuId }), { state })
                    setDisable(false)
                }, 1500);
            }
            else {
                toasterrormsg(res.message)
                setDisable(false)

            }
        }
    }

    //   restaurant list api call
    const restaurantListAPIcall = async () => {

        var param = {
            restaurantId: editRestaurantId
        }
        var res = await fetchData('vendor/public/restaurantDetail', param)

        if (res.status == "200") {
            var restaurantData = res.data
            setRestaurantDetails(restaurantData);
            var amenities: any = []
            restaurantData[0]['facilities'].map((val: any) => {
                amenities.push({ value: val.amenityId, label: getTranslatedValue(lang, val, '_name') })
            })
            setAmenitiesSelectedOptions(amenities)
            setOldAmenities(amenities)

            var ambience: any = []
            restaurantData[0]['ambience'].map((val: any) => {
                ambience.push({ value: val.ambienceId, label: getTranslatedValue(lang, val, '_name') })
            })
            setAmbienceSelectedOptions(ambience)
            setOldAmbience(ambience)
            const cuisine = restaurantData[0]['cuisine'][0]
            const cuisineObj = { value: cuisine.cuisineId, label: getTranslatedValue(lang, cuisine, '_name') }
            setCuisineSelectedOptions(cuisineObj)
            setOldCuisine(cuisineObj)
        }
        else {
            toasterrormsg(res.message)
        }
    }

    useEffect(() => {

        amenityListAPIcall();
        ambienceListAPIcall();
        cuisineListAPIcall();
        if (editRestaurantId != "") {

            restaurantListAPIcall();
        }
    }, [])

    return (
        <>
            <ToastContainer />
            <PageTitle breadcrumbs={[]}>{editRestaurantId != "" ? t('Edit Facilities & Services') : t('Add Facilities & Services')}</PageTitle>
            <AddRestaurantHeader restaurantId={editRestaurantId} />
            <div className="d-flex flex-column flex-column-fluid">
                {/* <!--begin::Content--> */}
                <div id="kt_app_content" className="app-content flex-column-fluid">
                    {/* <!--begin::Form--> */}
                    <div className="form d-flex flex-column flex-lg-row">
                        {/* <!--begin::Main column--> */}
                        <div className="d-flex flex-column flex-row-fluid gap-7 gap-lg-10">
                            {/* <!--begin::Tab content--> */}
                            <div className="tab-content">
                                {/* <!--begin::Tab pane--> */}
                                <div className="tab-pane fade show active" id="kt_ecommerce_add_product_general" role="tab-panel">
                                    <div className="d-flex flex-column">
                                        {/* <!--begin::General options--> */}
                                        <div className="card card-flush py-4">
                                            {/* <!--begin::Card header--> */}
                                            <div className="card-header d-flex">
                                                {/* <!--begin::Card title--> */}
                                                <div className="card-title">
                                                    <h2>{t("Property Facilities and Services")}</h2>
                                                </div>
                                                {/* <!--end::Card title--> */}
                                                <div className='d-flex align-items-center w-200px w-sm-300px flex-column'>
                                                    {
                                                        restaurantDetails.length != 0 ? (
                                                            <>
                                                                {
                                                                    restaurantDetails.map((completedSteps: any, index: any) => {
                                                                        var percentage = 0;
                                                                        if (completedSteps['completedSteps']['basicInfo']) {
                                                                            percentage = 10;
                                                                        }
                                                                        if (completedSteps['completedSteps']['location']) {
                                                                            percentage = 20;
                                                                        }
                                                                        if (completedSteps['completedSteps']['propertyDetail']) {
                                                                            percentage = 40;
                                                                        }
                                                                        if (completedSteps['completedSteps']['roomAndSpace']) {
                                                                            percentage = 50;
                                                                        }
                                                                        if (completedSteps['completedSteps']['photos']) {
                                                                            percentage = 60;
                                                                        }
                                                                        if (completedSteps['completedSteps']['facilitiesAndServices']) {
                                                                            percentage = 70;
                                                                        }
                                                                        if (completedSteps['completedSteps']['availability']) {
                                                                            percentage = 80;
                                                                        }
                                                                        if (completedSteps['completedSteps']['policies']) {
                                                                            percentage = 90;
                                                                        }
                                                                        if (completedSteps['completedSteps']['financeAndLegal']) {
                                                                            percentage = 100;
                                                                        }
                                                                        return (
                                                                            <>
                                                                                <div className='d-flex justify-content-between w-100 mt-auto'>
                                                                                    <span className='fw-bold fs-6'>{t("Completion")}</span>
                                                                                    <span className='fw-bolder fs-6'>{percentage}%</span>
                                                                                </div>
                                                                                <div className='h-5px mx-3 w-100 bg-light mb-3'>
                                                                                    <div
                                                                                        className='bg-success rounded h-5px'
                                                                                        role='progressbar'
                                                                                        style={{ width: `${percentage}%` }}
                                                                                    ></div>
                                                                                </div>
                                                                            </>
                                                                        )
                                                                    })
                                                                }
                                                            </>
                                                        ) : (
                                                            <>
                                                                <div className='d-flex justify-content-between w-100 mt-auto'>
                                                                    <span className='fw-bold fs-6'>{t("Completion")}</span>
                                                                    <span className='fw-bolder fs-6'>0%</span>
                                                                </div>
                                                                <div className='h-5px mx-3 w-100 bg-light mb-3'>
                                                                    <div
                                                                        className='bg-success rounded h-5px'
                                                                        role='progressbar'
                                                                        style={{ width: '0%' }}
                                                                    ></div>
                                                                </div>
                                                            </>
                                                        )
                                                    }
                                                </div>
                                            </div>
                                            {/* <!--end::Card header--> */}
                                            {/* <!--begin::Card body--> */}
                                            <div className="card-body pt-10">
                                                {/* <!--begin::Input group--> */}
                                                <div className="row">
                                                    <div className="col-lg-4 my-3">
                                                        {/* <!--begin::Label--> */}
                                                        <label className="required fs-4 form-label">{t("Select Facilities & Services")}</label>
                                                        {/* <!--end::Label--> */}
                                                        {/* <!--begin::Input--> */}
                                                        <Select
                                                            name='amenities[]'
                                                            id='amenitiesListId'
                                                            placeholder={t('Select Amenities')}
                                                            isSearchable={true}
                                                            isMulti
                                                            options={amenitiesList}
                                                            value={amenitiesSelectedOptions}
                                                            onChange={(e: any) => { setAmenitiesSelectedOptions(e); removeError("amenityId"); }}

                                                        />
                                                        {/* <!--end::Input--> */}
                                                        <div className='text-danger fw-bold'>{error[0].amenityId}</div>
                                                    </div>
                                                    <div className="col-lg-4 my-3">
                                                        {/* <!--begin::Label--> */}
                                                        <label className="required fs-4 form-label">{t("Select Ambience")}</label>
                                                        {/* <!--end::Label--> */}
                                                        {/* <!--begin::Input--> */}
                                                        <Select
                                                            name='ambienceList[]'
                                                            id='ambienceList'
                                                            placeholder={t('Select Ambience')}
                                                            isSearchable={true}
                                                            options={ambienceList}
                                                            isMulti
                                                            value={ambienceSelectedOptions}
                                                            onChange={(e: any) => { setAmbienceSelectedOptions(e); removeError("ambience"); }}
                                                        />
                                                        {/* <!--end::Input--> */}
                                                        <div className='text-danger fw-bold'>{error[0].ambience}</div>
                                                    </div>
                                                    <div className="col-lg-4 my-3">
                                                        {/* <!--begin::Label--> */}
                                                        <label className="fs-4 form-label required">{t("Select Cuisine Type")}</label>
                                                        {/* <!--end::Label--> */}
                                                        {/* <!--begin::Input--> */}
                                                        <Select
                                                            name='cuisine[]'
                                                            id='cuisine'
                                                            placeholder={t('Select Cuisine')}
                                                            isSearchable={true}
                                                            options={cuisineList}
                                                            value={cuisineSelectedOptions}
                                                            onChange={(e: any) => { setCuisineSelectedOptions(e); removeError("cuisineId"); }}
                                                        />
                                                        {/* <!--end::Input--> */}
                                                        <div className='text-danger fw-bold'>{error[0].cuisineId}</div>
                                                    </div>
                                                </div>
                                                {/* <!--end::Input group--> */}
                                            </div>
                                            {/* <!--begin::Card body--> */}
                                        </div>
                                        {/* <!--end::Pricing--> */}
                                    </div>
                                </div>
                                {/* <!--end::Tab pane--> */}
                            </div>
                            {/* <!--end::Tab content--> */}
                            <div className="d-flex justify-content-end">

                                <button type="button" disabled={disable} className="btn btn-primary" onClick={addRestaurantFacilitiesApi}>
                                    <span className="indicator-label">{t("Next")}</span>
                                    {loading && (
                                        <span className="spinner-border spinner-border-sm mx-2" role="status" aria-hidden="true"></span>
                                    )}
                                </button>
                                {/* <!--end::Button--> */}
                            </div>
                        </div>
                        {/* <!--end::Main column--> */}
                    </div>
                    {/* <!--end::Form--> */}
                </div>
                {/* <!--end::Content--> */}
            </div>
        </>
    )
}

export { AddRestaurantFacilities }
